import React from 'react';
import {ILiceInfo} from "../../util/varibles/interface";

interface IProps {
    lice?: ILiceInfo
    wrapperClass?: string
}

const UnitLice: React.FC<IProps> = ({lice = {}, wrapperClass}) => {
    if (Object.keys(lice).length === 0)
        return <>-</>;

    const {stationary_lice, mobile_lice, female_lice} = lice;
    const stationary = Math.round((stationary_lice?.value || 0) * 100) / 100;
    const mobile = Math.round((mobile_lice?.value || 0) * 100) / 100;
    const female = Math.round((female_lice?.value || 0) * 100) / 100;
    const total_lice = stationary + mobile + female;

    return <span className={['whitespace-nowrap', wrapperClass].join(' ')}>
        <span className='total_lice'>{Math.round(total_lice * 100) / 100}</span>
        <span className='ml-[3px]'>({`${stationary}, ${mobile}, ${female}`})</span>
    </span>
};

export default UnitLice;
